import { Box, Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SubmitBtn from "../../components/button/SubmitBtn";
import fb_icon from "../../img/fb_icon.svg";
import ig_icon from "../../img/ig_icon.svg";
import linkedIn_icon from "../../img/linkedIn_icon.svg";
import { getProfile, getUserProfile } from "../../services/PersonalService";
import { RootStoreContext } from "../../store";
import style from "./Personal.module.css";

function Personal() {
  const { PersonalStore } = useContext(RootStoreContext);
  const { profile_picture, softPower, hardPower, motivation, igLink, fbLink, linkedInLink } =
    PersonalStore;
  const { username, gender, birthday, email, experience, deeds } =
    PersonalStore;
  const [userData, setUserData] = useState({
    username: username,
    profile_picture: profile_picture,
    gender: gender,
    birthday: birthday,
    email: email,
    experience: experience,
    deeds: deeds || [""],
    softPower: softPower,
    hardPower: hardPower,
    motivation: motivation,
    igLink: igLink,
    fbLink: fbLink,
    linkedInLink: linkedInLink,
  });

  let userId = null;
  try {
    const location = useLocation();
    const { id } = location.state;
    userId = id;
  } catch (e) {
    console.log(e);
  }
  useEffect(() => {
    if (userId !== null) {
      getUserProfile(userId)
        .then((value) => {
          setUserData(value);
        })
        .catch(console.log);
    } else {
      getProfile()
        .then((value) => {
          const tmp = { ...userData, ...value };
          setUserData(tmp);
        })
        .catch(console.log);
    }
  }, []);


  return (
    <Box className={style.container}>
      <Grid
        container
        className={style.main}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          style={{ textAlign: "center" }}
          className={style.mid}
        >
          <img
            src={userData.profile_picture ?? ''}
            alt="profile"
            className={style.img}
          />
          <br />
          {userData.username ?? ''}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1em"
          }}>
            <a href={userData.igLink} target="_blank" rel="noreferrer noopener" style={{ pointerEvents: !userData.igLink?.startsWith("http") && "none" }}><img src={ig_icon} alt="ig_icon" /></a>
            <a href={userData.linkedInLink} target="_blank" rel="noreferrer noopener" style={{ pointerEvents: !userData.linkedInLink?.startsWith("http") && "none" }}>
              <img src={linkedIn_icon} alt="linkedIn_icon" style={{
                marginLeft: "0.75em",
                marginRight: "1em"
              }} />
            </a>
            <a href={userData.fbLink} target="_blank" rel="noreferrer noopener" style={{ marginTop: "-0.1%", marginLeft: "0.2%", pointerEvents: !userData.fbLink?.startsWith("http") && "none" }}>
              <img src={fb_icon} alt="fb_icon" />
            </a>
          </Box>
          <Link
            to="/Profile"
            className={style.submit}
            style={{
              visibility: email !== userData.email && "hidden",
              marginBottom: "25px",
            }}
          >
            <SubmitBtn label="編輯" />
          </Link>
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={0} lg={2} />
              <Grid item xs={12} lg={4}>
                <div className={style.wblock}>
                  {userData.username ?? ''}
                </div>
                <div className={style.wblock1}>
                  {userData.gender ?? ''}
                </div>
                <div className={style.wblock2}>
                  {moment(userData.birthday ?? '2022/01/01').format("YYYY/MM/DD")}
                </div>

                <div className={style.wblock}>
                  {userData.experience ?? ''}
                </div>
              </Grid>
              <Grid item xs={12} lg={4}>
                <div className={style.wblock}>
                  軟實力
                  <br />
                  {userData.softPower ?? ''}
                </div>
                <div className={style.wblock}>
                  硬實力
                  <br />
                  {userData.hardPower ?? ''}
                </div>
                <div className={style.wblock}>
                  創業動機
                  <br />
                  {userData.motivation ?? ''}
                </div>
              </Grid>
              <Grid item xs={0} lg={2} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default observer(Personal);
